import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { RegistrationSourceType } from '../../../../../api/types/external-exams/registration/external-exam-student-registration-eligibility';

export const registerExternalExamOperation = async (
  groupId: number,
  examId: number,
  registrationId: number,
  setRegistrationId: (registrationId: number | null) => any,
  onSuccess: () => void,
) => {
  try {
    setRegistrationId(registrationId);

    const res = await appApi.registerExternalExam(
      groupId,
      examId,
      registrationId,
      RegistrationSourceType.ADMIN,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    } else if (res.data.ok) {
      toast.success('הרשמה למבחן בוצעה בהצלחה');
      onSuccess();
    }

    setRegistrationId(null);
  } catch (e) {
    toast.error('הרשמה למבחן נכשלה, נסה שוב בעוד מספר רגעים...');
    console.error(
      `registerExternalExamOperation failed for groupId: ${groupId}, examId: ${examId}, registrationId: ${registrationId} with error: ${e}`,
    );
    setRegistrationId(null);
  }
};
